module.exports = {
  REACT_APP_BACKEND_URL:
    process.env.REACT_APP_BACKEND_URL ?? "https://api.prod.sappay.net",
};
